import React from 'react';

import {
  FormCheckbox,
  FormSelect,
} from '@uncinc/uncinc-react-kitchen-sink';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

export interface Filter {
  [key: string]: string;
}

export interface FilterProps {
  filters: Filter[];
  filter: ImmutableEntity<any>;
  onChange: (key: string, value: any) => void;
}

const ViewFilter: React.FC<FilterProps> = (props) => {
  const { filters, filter, onChange } = props;

  const filterLabel = filter.getIn(['expose', 'label']);
  const filterIdentifier = filter.getIn(['expose', 'identifier']);
  const filterField = filter.get('field');
  const filterOptions = filter.get('options');

  switch (filter.get('plugin_id')) {
    case 'boolean': {
      return (
        <div className="ViewFilters__filter">
          <FormCheckbox
            title={filterLabel}
            fieldName={filterField}
            onChange={(value: any) => onChange(filterIdentifier, value ? 1 : 0)}
          />
        </div>
      );
    }

    case 'combine':
    case 'entity_reference_tree_inline_filter': {
      const defaultValue = filterOptions.find((item: ImmutableEntity<any>) => (
        item.get('value') === filters[filterIdentifier]
      )) || null;

      return (
        <div className="ViewFilters__filter">
          <FormSelect
            title={filterLabel}
            fieldName={filterField}
            options={filterOptions.toJS()}
            selectedOption={defaultValue ? defaultValue.toJS() : null}
            onChange={(value: number) => onChange(filterIdentifier, value)}
            defaultFilters={filters[filterIdentifier]}
          />
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

export default ViewFilter;
